import type { Layer, PieceModel, TimeMs } from './types';

export type AudioSource = {
  src: string;
  /** When it starts in the piece. */
  start: TimeMs;
  duration: TimeMs;
  /** Offset into the source file. */
  offset: TimeMs;
  gain: number;
};

const collect = (layers: Layer[], out: AudioSource[]): void => {
  for (const layer of layers) {
    if (layer.kind === 'audio') {
      out.push({
        src: layer.content.src,
        start: layer.start,
        duration: layer.duration,
        offset: layer.content.trim?.in ?? 0,
        gain: layer.content.gain ?? 1
      });
      continue;
    }

    // A video's own audio (an avatar's voice) plays from the start of its clip.
    if (layer.kind === 'video') {
      if (layer.content.audioEnabled === true) {
        out.push({
          src: layer.content.src,
          start: layer.start,
          duration: layer.duration,
          offset: 0,
          gain: 1
        });
      }
      continue;
    }

    if (layer.kind === 'group') collect(layer.content.children, out);
  }
};

/**
 * Everything the piece should be heard playing, as plain data. Preview volume
 * and mute are monitoring controls and deliberately left out.
 */
export const resolveAudioSources = (model: PieceModel): AudioSource[] => {
  const sources: AudioSource[] = [];
  collect(Object.values(model.layers), sources);
  return sources;
};
